import React, { Component } from "react";
import Information from "../Information";
import Store from "../../../content/Store";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";
import { Paths } from "../../../constants/UrlConstants";
import Contentify from "../../../content/Contentify";
import styles from "../../../assets/css/modules/information/errors/online-access-unavailable.css";
import Button from "../../shared/buttons/Button";
import { withRouter } from "react-router-dom";

import OnlineAccessUnavailableImage from "../../../assets/img/Refresh-images/OnlineAccessUnavailableImage.png";
import OnlineAccessInformation from "../OnlineAccessInformation";
// import ErrorInformation from "../ErrorInformation";
import LOGOUT from "../../logout/Logout";
import { Link } from "react-router-dom";
import Content from "../../../content/Content";
import { connect } from "react-redux";



const floatLink = {
  float: "left",
  paddingTop: "10px"
};

export class OnlineAccessUnavailable extends Component {
  static content = Store.ErrorPages.OnlineAccessUnavailable;

  render() {
    return (
      <div>
        {this.props.layout === 'MOL' ?(
      <div className="container">
        <div className="row container-row-online">
          <div className="col-xl-7">
            <OnlineAccessInformation headerText={this.props.content.HeaderText}>
              {this.props.content.Message}
              <div className="Add-New-Pan-Button_Position">
              <Button
                onClick={() =>
                  this.props.history.push(Paths.AddAPlanFromNoAccess)
                }
                label={this.props.content.AddANewPlanLinkText}
              />
              </div>
              <div className="online-second-header-text">
                {this.props.content.HeaderTextsecond}
              </div>
              {/* <OnlineAccessInformation headerText={this.props.content.HeaderTextsecond}></OnlineAccessInformation> */}
              <div className="online-second-message-text">
              {this.props.content.Messagesecond}</div>
              <div className="online-second-third-text">
              {this.props.content.Messagethird}</div>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  {/* <ErrorContentLinks /> */}
                  <div style={floatLink}>
                  <div className="row">
                    <div className="col-4 float-left">
                      <p className={styles.sharedErrorContent}><LOGOUT timeout="timeout" /></p>
                    </div>
                    <div className="col-3 float-right">
                      <Link to={Paths.LoggedOut}>
                        <Content name={Store.ErrorPages.OnlineAccessUnavailable.Link} />
                      </Link>
                    </div>
                  </div>
                  </div>
                </div>
                <div className={`${styles.addAPlanLink} col-lg-6 col-md-6 col-sm-12`}>
                  {/* <Button
            onClick={() =>
              this.props.history.push(Paths.AddAPlanFromNoAccess)
            }
            label={this.props.content.AddANewPlanLinkText}
          /> */}
                </div>
              </div>
            </OnlineAccessInformation>
          </div>
          <div className="col-md-5 col-lg-5 col-sm-5 d-none d-sm-block">
            <div className="container">
              <img className="d-none d-sm-block imgonlineaccess" src={OnlineAccessUnavailableImage} alt="" />
            </div>
          </div>
        </div>
      </div>):(
      <Information headerText={this.props.content.HeaderText}>
        {this.props.content.Message}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <ErrorContentLinks />
          </div>
          <div className={`${styles.addAPlanLink} col-lg-6 col-md-6 col-sm-12`}>
            <Button
              onClick={() =>
                this.props.history.push(Paths.AddAPlanFromNoAccess)
              }
              label={this.props.content.AddANewPlanLinkText}
            />
          </div>
        </div>
      </Information>
      )}
      </div>
    );
  }
}

// export default withRouter(Contentify(OnlineAccessUnavailable));
export const mapStateToOnlineAccessUnavailable = (state) => {
  console.log(state.layoutReducer.layout);
  return {
    layout: state && state.layoutReducer && state.layoutReducer.layout,
    
  };
};

export default withRouter(
  connect(mapStateToOnlineAccessUnavailable)(Contentify(OnlineAccessUnavailable))
);
